import ModuleBuilder from '@v/store/ModuleBuilder.js'
import BookingForEditorApiModel from '@v/bookings/edit/models/BookingForEditorApiModel.js'
import { any, propEq, reduce, pipe, find, prop, filter } from 'ramda'
import { getBookingDeals } from '@v/bookings/edit/util/bookingDealFunctions.js'

export default function createModule(apiClient) {
  const url = key => `/bookings/foreditor${key ? `?bookingKey=${key}` : ''}`
  const saveUrl = key => (key ? `/bookings/${key}/update` : 'bookings/create')
  const bookingModule = new ModuleBuilder(apiClient)
    .withAsyncModel({
      fetchModelName: 'forEditorModel',
      saveModelName: 'booking',
      url,
      saveUrl,
      fetchResponseMapper: x => new BookingForEditorApiModel(x),
    })
    .build()
  // extra state
  bookingModule.state.booking = null
  bookingModule.state.bookingDeals = null
  bookingModule.state.scheduledProductsIncHelper = 0
  // extra mutations
  bookingModule.mutations.setBooking = (state, booking) => {
    state.booking = booking
    const products = state.forEditorModel?.Products
    state.bookingDeals = getBookingDeals(products)(booking.BookingProducts || [])
  }
  bookingModule.mutations.removeBookingDeal = (state, dealKey) => {
    const filteredBookingProducts = filter(p => p.ProductGroupKey !== dealKey)(
      state.booking.BookingProducts,
    )
    state.booking.BookingProducts = filteredBookingProducts
    const products = state.forEditorModel?.Products
    state.bookingDeals = getBookingDeals(products)(filteredBookingProducts || [])
  }
  bookingModule.mutations.updateBookingDeals = state => {
    const bookingProducts = state.booking?.BookingProducts || []
    const products = state.forEditorModel?.Products || []
    state.bookingDeals = getBookingDeals(products)(bookingProducts)
  }
  bookingModule.mutations.incrementScheduledProductsIncHelper = state => {
    state.scheduledProductsIncHelper = state.scheduledProductsIncHelper + 1
  }
  // extra getters
  bookingModule.getters.products = state => state.forEditorModel?.Products
  bookingModule.getters.scheduledProductsIncHelper = state => state.scheduledProductsIncHelper
  bookingModule.getters.resources = state => state.forEditorModel?.Resources
  bookingModule.getters.classifications = state => state.forEditorModel?.Classifications
  bookingModule.getters.booking = state => state.booking
  bookingModule.getters.bookingProducts = state => state.booking.BookingProducts
  bookingModule.getters.hasDeletedProducts = (state, getters) =>
    getters.bookingProducts
      ? any(propEq('ProductActiveState', 'Deleted'), getters.bookingProducts)
      : false
  bookingModule.getters.flatSegments = (state, getters) =>
    reduce((agg, next) => agg.concat(next.Segments), [], getters.classifications || [])
  bookingModule.getters.bookingDeals = (state, getters) => state.bookingDeals // The result of getBookingDeals should not be reactive because deal quantities need to behave independently from product quantities
  return bookingModule
}
